import axios from "axios";
import Cook from "./cookie";
import store from "../store";
import { Message } from "element-ui";
import { language } from "../language/get";
// import { delete } from "vue/types/umd";
const lang = language();
//const baseUrl = 'https://livei.shippingchina.com';
//const baseUrl = 'http://localhost:8082';
const baseUrl = 'https://goapi.shippingchina.com';
axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
axios.interceptors.request.use(config => {
  if (localStorage.getItem("token")) {
    config.headers['token'] = localStorage.getItem("token");
  }
  //config.headers['Authorization'] = localStorage.getItem("token");
  return config;
})

axios.interceptors.response.use(response => {
  sessionStorage.setItem("url", response.config.url)
  store.commit("setapiurl", response.config.url)
  // if (response.data.type === -1) {
  //   localStorage.removeItem("token")
  //   // Message.error({
  //   //     message: lang.overtime,
  //   //     offset: 120,
  //   //     duration: 5000
  //   // })
  //
  //   store.dispatch("Logout", { token: store.getters.token });
  //   window.location.href = "index.html"
  // } else {
  //   //return response;
  // }

  return response;
})
axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url 修改当前访问地址
  timeout: process.env.NODE_ENV === "development" ? 0 : 10000  //请求响应时间
});
export default {
  /**
   *
   * 后台API接口地址
   正式
   */
  adminapi: 'https://jobxcx.wiffa-edu.com/adminapi.php/Home/', //正式
  apiUrl: "https://jobxcx.wiffa-edu.com/api.php", //正式
  // adminapi: 'https://test.blnyingyu.com/jobFair/adminapi.php/Home/', //测试
  // apiUrl: "https://test.blnyingyu.com/jobFair/api.php", //测试


  /**
   *
   * @param url 地址
   * @param param 参数
   * @param isEn 是否包含中英文
   * @returns {Promise<unknown>}
   */
  send: function (url, param, isEn) {
    param = JSON.stringify(param)
    if (param != undefined)
      param = JSON.parse(param);
    if (param != undefined && param.hasOwnProperty("token"))
      delete param.token;
    var lan = Cook.get("lang");
    // 线上
    if (url.indexOf('http') == -1) {
       // url = "https://exhxcx.shippingchina.com/api.php/Home" + url;
       url = this.apiUrl + '/Home'+ url;
    }
    // 测试
    if (url.indexOf('http') == -1) {
     // url = "https://exhixcx.shippingchina.com/api.php/Home" + url;
      // url = "http://192.168.1.31/api.php/Home/" + url;
     // url = 'http://aa.xue.com/api.php/Home/' + url;

    }
    if (isEn == true && lan == "en") {
      url = url + "_En"
    }
    console.log(param,url)
    return new Promise(function (resolve) {
      axios.post(url, param, {}).then(function (result) {
        var res = result.data;
        if (res.type == "-1") {

            console.log('request error', JSON.stringify(param), JSON.stringify(result));
            Message.error({
              message: lang.overtime,
              offset: 120,
              duration: 5000
            })
            localStorage.clear();
            store.dispatch("Logout", { token: store.getters.token });
            window.location.href = "login.html"
            return;

        }
        resolve(res);
      })
    })
  },
  export: function (url, param, _this) {
    url = this.apiUrl + '/Home' + url;
    return new Promise(function (resolve) {
      axios({
        method: 'post',
        url: url,
        data: param,
        responseType: 'blob'
      }).then(result => {
        var res = result.data;

        resolve(res);
      }).catch(err => {
        console.log(err)
      })
    })
  },
  getRequest: async (url, param) => {

    return await axios.get(baseUrl + url, {
      params: param
    })
  },

  postRequest: async (url, param) => {
    return await axios.post(baseUrl + url, param)
  },

  putRequest: async (url, param) => {
    return await axios.put(baseUrl + url, param)
  },

  deleteRequest: async (url, param) => {
    return await axios.delete(baseUrl + url, param)
  }
};
